import { type ReactNode } from "react";
import { Icon, type SemanticICONS } from "semantic-ui-react";
import classNames from "classnames/bind";
import styles from "./AccountMenuItem.module.scss";

const cx = classNames.bind(styles);

type Props = {
  text: string;
  onClick: () => void;
  active?: boolean;
} & ({ iconClass: SemanticICONS | string; icon?: never } | { iconClass?: never; icon: ReactNode });

export const AccountMenuItem: React.FC<Props> = ({ text, iconClass, onClick, active, icon }) => {
  return (
    <button
      className={cx(styles.root, {
        [styles.active]: active,
      })}
      onClick={onClick}
    >
      <span className={styles.iconWrapper}>{icon || <Icon className={iconClass} />}</span>
      <span className={styles.text}>{text}</span>
    </button>
  );
};
